import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AssessmentEmployeesResults } from '@qaroni-app/assessment/types/assessment-employees-results';
import { AssessmentResultsAddCommentDialogData } from '@qaroni-app/assessment/types/assessment-results-add-feedback-dialog-data';
import { AssessmentResultsCommentsRegisterForm } from './assessment-results-comments-register.form';

@Component({
  selector: 'qaroni-assessment-results-comments-register',
  templateUrl: './assessment-results-comments-register.component.html',
  styleUrls: ['./assessment-results-comments-register.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AssessmentResultsCommentsRegisterComponent
  extends AssessmentResultsCommentsRegisterForm
  implements OnInit
{
  data = inject<AssessmentResultsAddCommentDialogData>(MAT_DIALOG_DATA);
  route = inject(ActivatedRoute);
  dialogRef =
    inject<MatDialogRef<AssessmentResultsCommentsRegisterComponent>>(
      MatDialogRef
    );

  public employeesList: AssessmentEmployeesResults[] = [];
  public showEmployeesList = true;

  ngOnInit(): void {
    this.populateForm();
  }

  public onSubmit() {
    if (!this.form.valid) {
      return;
    }
    this.dialogRef.close(this.form.value);
  }

  private populateForm() {
    this.employeesList = this.data.employees;
    if (this.data.comment) {
      this.form.patchValue(this.data.comment);
    }
    if (this.data.showEmployeesList !== undefined) {
      this.showEmployeesList = this.data.showEmployeesList;
    }
    if (this.data.employeeID) {
      this.employeeId.setValue(this.data.employeeID);
      this.employeeId.disable();
    }
  }
}
